import { h } from 'vue';
import { RouterLink } from 'vue-router';

// Utils
import { Text } from '@/utils';

// Mixinx
import { props, computed } from './mixin';

export default {

    mixins: [props, computed],

    render()
    {
        return h(
            RouterLink,
            {
                class: [
                    this.classes,

                    this.divClass
                ],

                disabled: this.disabled || this.loading,

                to: this.href
            },

            this.loading ?
                h(
                    'transition',
                    {
                        on:
                        {
                            name: 'fade',
                            mode: 'out-in',
                        },
                    },
                    [
                        h(
                            'i',
                            {
                                class: Text.joinClass(
                                    'fa',
                                    'fa-spinner',
                                    'fa-lg',
                                    'vh-animate',
                                    'vh-animate-infinite',
                                    'vh-animate-rotate'
                                ),
                            }
                        ),
                    ]
                )
                : this.$slots,
        );
    },
};
